// Message the before_user_created auth hook returns when an active student row already owns the email.
export const EXISTING_STUDENT_ACCOUNT_HOOK_MESSAGE = 'existing-student-account';

// `?error=` value the auth pages render as "please sign in to your student account".
export const EXISTING_STUDENT_ACCOUNT_ERROR_CODE = 'existing-student-account';

export const isExistingStudentAccountAuthError = (error: { message?: string } | null | undefined): boolean =>
  error?.message === EXISTING_STUDENT_ACCOUNT_HOOK_MESSAGE;

// Supabase relays a hook refusal to the OAuth/SAML redirect as error_description, with no status.
export const isExistingStudentAccountRedirect = (searchParams: URLSearchParams): boolean =>
  searchParams.get('error_description') === EXISTING_STUDENT_ACCOUNT_HOOK_MESSAGE;
